import { RootState } from '..';
import { VariantPayload } from './slice';

function isValidVariant(payload: VariantPayload<any>): boolean {
  return payload && payload.hasOwnProperty('enabled') && payload.hasOwnProperty('value');
}

export const FeatureFlagSelector = {
  getFeatures: (state: RootState) => state.featureFlag.features,
  isLoading: (state: RootState) => state.featureFlag.status === 'idle',
  isFeatureFlagEnabled: (state: RootState, key: string, defaultValue: boolean = false): boolean => {
    const feature = state.featureFlag.features[key];
    if (
      feature &&
      feature.enabled &&
      feature?.variant &&
      feature?.variant?.payload?.type === 'json'
    ) {
      try {
        const parsed = JSON.parse(feature.variant.payload.value) as VariantPayload<any>;
        return parsed.enabled ?? defaultValue;
      } catch (e) {
        return defaultValue;
      }
    }
    return defaultValue;
  },
  getVariant: <T = any>(state: RootState, key: string, defaultValue: T): T | null => {
    const feature = state.featureFlag.features[key];

    if (feature && feature.variant && feature.enabled) {
      switch (feature?.variant?.payload?.type) {
        case 'json': // we only use json for now
          try {
            const payload = JSON.parse(feature.variant.payload.value) as VariantPayload<T>;
            return isValidVariant(payload) ? payload.value : defaultValue;
          } catch (e) {
            return defaultValue;
          }
        default:
          return defaultValue;
      }
    }
    return defaultValue;
  },
};
